module.exports = __webpack_public_path__ + "static/media/close.f1d56225.svg";